// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_32rZh","itemLink":"index_itemLink_1qhZJ","itemPic":"index_itemPic_szGLC","itemIcon":"index_itemIcon_2v7ni"};